import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Scale, LogIn } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await axios.post(`${API}/admin/login`, { email, password }, { withCredentials: true });
      onLogin();
    } catch {
      setError("Invalid email or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#1a1a2e] flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-10">
          <Scale className="h-10 w-10 text-[#1a5c4a] mx-auto mb-4" />
          <h1 className="font-heading text-2xl font-extrabold text-white tracking-[-0.02em]">Admin Portal</h1>
          <p className="text-white/40 text-sm mt-2">Legal Associates & Co</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5" data-testid="admin-login-form">
          <div>
            <label className="block text-xs font-medium text-white/50 mb-2 uppercase tracking-wider">Email</label>
            <Input
              data-testid="admin-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@admin.com"
              className="rounded-xl bg-white/5 border-white/10 text-white placeholder:text-white/30 h-12 focus:border-[#1a5c4a] focus:ring-[#1a5c4a]"
              required
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-white/50 mb-2 uppercase tracking-wider">Password</label>
            <Input
              data-testid="admin-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              className="rounded-xl bg-white/5 border-white/10 text-white placeholder:text-white/30 h-12 focus:border-[#1a5c4a] focus:ring-[#1a5c4a]"
              required
            />
          </div>

          {error && <p data-testid="admin-login-error" className="text-red-400 text-sm text-center">{error}</p>}

          <Button
            type="submit"
            data-testid="admin-login-btn"
            disabled={loading}
            className="w-full bg-[#1a5c4a] text-white hover:bg-[#154a3c] rounded-full h-12 font-semibold transition-all"
          >
            {loading ? "Signing in..." : <><LogIn className="h-4 w-4 mr-2" />Sign In</>}
          </Button>
        </form>
      </div>
    </div>
  );
}
